import { InjectionKey, Ref } from 'vue'
import { DocumentAcceptance } from '@/utils/types/document'

const selectedUsersKey: InjectionKey<Ref<number[]>> = Symbol('selectedUsersKey')
const selectedDepartmentsKey: InjectionKey<Ref<number[]>> = Symbol(
  'selectedDepartmentsKey'
)
const existAcceptanceListKey: InjectionKey<DocumentAcceptance[]> = Symbol(
  'existAcceptanceListKey'
)
const existDepartmentIdsKey: InjectionKey<number[]> = Symbol(
  'existAcceptanceListKey'
)
const existUserIdsKey: InjectionKey<number[]> = Symbol('existAcceptanceListKey')
const usersToDeleteKey: InjectionKey<Ref<number[]>> = Symbol('usersToDeleteKey')

export {
  selectedUsersKey,
  selectedDepartmentsKey,
  existAcceptanceListKey,
  existDepartmentIdsKey,
  existUserIdsKey,
  usersToDeleteKey,
}
